'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactBootstrap = require('react-bootstrap');

var _reactRouter = require('react-router');

var _shops = require('redux/modules/shops');

var shopActions = _interopRequireWildcard(_shops);

var _voucher = require('redux/modules/voucher');

var voucherActions = _interopRequireWildcard(_voucher);

var _lodash = require('lodash');

var _reactRedux = require('react-redux');

var _lib = require('helpers/lib');

var _numeral = require('numeral');

var _numeral2 = _interopRequireDefault(_numeral);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _components = require('components');

var _reduxAsyncConnect = require('redux-async-connect');

var _LocationDetail = require('../Detail/LocationDetail');

var _LocationDetail2 = _interopRequireDefault(_LocationDetail);

var _GalleryDetail = require('../Detail/GalleryDetail');

var _GalleryDetail2 = _interopRequireDefault(_GalleryDetail);

var _VoucherHorizontalList = require('components/Box/VoucherHorizontalList');

var _VoucherHorizontalList2 = _interopRequireDefault(_VoucherHorizontalList);

var _defaultVoucherImage = require('assets/img/voucher/defaultVoucherImage.jpg');

var _defaultVoucherImage2 = _interopRequireDefault(_defaultVoucherImage);

var _expiredVoucherImage = require('assets/img/voucher/expiredVoucherImage.jpg');

var _expiredVoucherImage2 = _interopRequireDefault(_expiredVoucherImage);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PromotionDetail = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState,
        handle = _ref.params.handle;

    var promises = [];
    if (!voucherActions.isLoadedVoucher(getState())) {
      promises.push(dispatch(voucherActions.getRewardDetailServer(handle)));
    }
    return _promise2.default.all(promises);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    shop: state.shops.shop,
    PACKAGE_DETAIL: state.voucher.PACKAGE_DETAIL,
    loading: state.shops.loading_detail,
    loaded: state.shops.loaded_detail
  };
}, (0, _extends3.default)({}, shopActions, voucherActions)), _dec(_class = _dec2(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(PromotionDetail, _Component);

  function PromotionDetail() {
    var _ref2;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, PromotionDetail);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref2 = PromotionDetail.__proto__ || (0, _getPrototypeOf2.default)(PromotionDetail)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
      activeTab: 'descript',
      fixedTab: false,
      id: '',
      loaded: false,
      showModalAlert: false,
      voucherHandle: _this.props.params.handle
    }, _this.onErrorImage = function (event) {
      event.target.onerror = null;
      event.target.src = _defaultVoucherImage2.default;
    }, _this.scrollToDomRef = function (id) {
      var domNode = _reactDom2.default.findDOMNode(_this.refs[id]).offsetTop;
      // window.scrollTo(domNode.y, 92);
      if (_this.state.fixedTab) {
        domNode -= 60;
      } else {
        domNode -= 125;
      }
      domNode = domNode < 420 ? 420 : domNode;
      try {
        window.scrollTo({
          top: domNode,
          behavior: 'smooth'
        });
        document.body.scrollTo({
          top: domNode,
          behavior: 'smooth'
        });
      } catch (err) {
        console.log(err);
      }
      _this.setState({ activeTab: id });
    }, _this.handleCloseModalAlert = function (value) {
      _this.setState({ showModalAlert: value });
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(PromotionDetail, [{
    key: 'componentDidMount',
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.props.getRewardDetail(this.props.params.handle);

              case 2:
                this.props.getShopData(this.props.PACKAGE_DETAIL.data.shop.handle);

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _ref3.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.props.getRewardDetail(this.props.params.handle);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!(0, _lodash.isEqual)(this.props.PACKAGE_DETAIL.data, nextProps.PACKAGE_DETAIL.data) && nextProps.PACKAGE_DETAIL.data) {
        this.props.getShopData(nextProps.PACKAGE_DETAIL.data.shop.handle);
      }
      if (this.props.params.handle !== nextProps.params.handle && this.props.params.handle) {
        this.props.getRewardDetail(nextProps.params.handle);
        this.setState({ voucherHandle: nextProps.params.handle });
        this.setState({ activeTab: 'descript' });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./PromotionDetail.scss');
      var _props = this.props,
          shop = _props.shop,
          loading = _props.loading,
          data = _props.PACKAGE_DETAIL.data,
          location = _props.location;

      var voucherLoading = this.props.PACKAGE_DETAIL.loading;
      var _state = this.state,
          showModalAlert = _state.showModalAlert,
          fixedTab = _state.fixedTab,
          activeTab = _state.activeTab,
          voucherHandle = _state.voucherHandle;

      var meta = [];
      var imageSeo = data ? data.image : '';
      imageSeo = data && data.imageSeo ? data.imageSeo : imageSeo;
      if (imageSeo) {
        meta.push({ property: 'og:image', content: imageSeo });
      }
      var url = location ? _config2.default.siteUrl + location.pathname : '';
      if (url) {
        meta.push({ property: 'og:url', content: url });
      }
      var title = data && data.campaign.name ? data.campaign.name : '';
      title = data && data.shop.address ? title + '-' + data.shop.address : title;
      if (title) {
        meta.push({ property: 'og:title', content: title });
      }
      var description = data && data.service.description ? (0, _lib.stripHtmlTags)(data.service.description) : '';
      if (description) {
        meta.push({
          name: 'description',
          property: 'og:description',
          content: description
        });
        meta.push({ name: 'description', content: description });
      }
      var expired = void 0;
      if (data) {
        expired = new Date() > (0, _moment2.default)(data.campaign.endDate);
      }
      return _react2.default.createElement(
        'div',
        { className: styles.detail },
        _react2.default.createElement(_reactHelmet2.default, { title: title, meta: meta }),
        loading && _react2.default.createElement(_components.Loading, null),
        _react2.default.createElement(
          'div',
          { className: 'container' },
          !loading && data && _react2.default.createElement(
            'div',
            { className: styles.topContent },
            _react2.default.createElement(
              'div',
              { className: styles.image },
              _react2.default.createElement(
                'div',
                { className: styles.bannerImage },
                '\u01AFU \n \u0110\xC3I'
              ),
              expired ? _react2.default.createElement('img', { src: _expiredVoucherImage2.default }) : _react2.default.createElement('img', {
                src: (0, _lib.getUrlImage)(data.image),
                alt: (data ? data.shop.name : 'detail') + ' avatar',
                onError: this.onErrorImage
              })
            ),
            _react2.default.createElement(
              'div',
              { className: styles.leftContent },
              _react2.default.createElement(
                'div',
                { className: styles.primary },
                _react2.default.createElement(
                  'h1',
                  { className: styles.name },
                  data.campaign.name
                )
              ),
              _react2.default.createElement(
                'div',
                { className: styles.extra },
                _react2.default.createElement(
                  'div',
                  { className: styles.openingTime },
                  _react2.default.createElement(_reactBootstrap.Glyphicon, { className: styles.icon, glyph: 'map-marker' }),
                  data.shop.name,
                  ' ',
                  _react2.default.createElement(
                    _reactRouter.Link,
                    {
                      className: styles.shopDetail,
                      to: '/' + data.shop.handle
                    },
                    '(Th\xF4ng tin shop)'
                  )
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.address },
                  _react2.default.createElement(_reactBootstrap.Glyphicon, { className: styles.icon, glyph: 'fire' }),
                  data.campaign.name
                ),
                _react2.default.createElement(
                  'div',
                  { className: styles.priceRange },
                  _react2.default.createElement(_reactBootstrap.Glyphicon, { className: styles.icon, glyph: 'tag' }),
                  '\u01AFu \u0111\xE3i: t\u1EEB ng\xE0y ',
                  (0, _lib.formatDate)(data.campaign.startDate),
                  ' \u0111\u1EBFn ',
                  (0, _lib.formatDate)(data.campaign.endDate)
                ),
                _react2.default.createElement(
                  'div',
                  {
                    className: styles.price,
                    style: expired ? { color: 'red' } : null
                  },
                  expired ? null : _react2.default.createElement(_reactBootstrap.Glyphicon, { className: styles.icon, glyph: 'usd' }),
                  _react2.default.createElement(
                    'span',
                    { className: styles.newPrice },
                    expired ? '\u0110\xC3 H\u1EBET H\u1EA0N' : (0, _numeral2.default)(data.displayValue).format('0,0') + 'đ'
                  ),
                  _react2.default.createElement(
                    'span',
                    { className: styles.oldPrice },
                    (0, _numeral2.default)(data.service.price).format('0,0') + 'đ'
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                {
                  onClick: function onClick() {
                    return _this2.handleCloseModalAlert(true);
                  },
                  className: styles.bookingButton
                },
                'L\u1EA5y Voucher'
              )
            )
          ),
          !loading && data && shop && _react2.default.createElement(
            'div',
            { className: styles.bodyContent },
            _react2.default.createElement(
              'div',
              { className: styles.tabs },
              _react2.default.createElement(
                'div',
                {
                  className: styles.headerTabContainer + (fixedTab ? ' ' + styles.fixedTabbar : '')
                },
                _react2.default.createElement(
                  'div',
                  { className: styles.headerTabs },
                  _react2.default.createElement(
                    'div',
                    {
                      onClick: function onClick() {
                        return _this2.scrollToDomRef('descript');
                      },
                      className: activeTab === 'descript' ? styles.activeTab : ''
                    },
                    'M\xF4 t\u1EA3 d\u1ECBch v\u1EE5'
                  ),
                  _react2.default.createElement(
                    'div',
                    {
                      onClick: function onClick() {
                        return _this2.scrollToDomRef('comment');
                      },
                      className: activeTab === 'comment' ? styles.activeTab : ''
                    },
                    '\u0110i\u1EC1u kho\u1EA3n s\u1EED d\u1EE5ng'
                  ),
                  _react2.default.createElement(
                    'div',
                    {
                      onClick: function onClick() {
                        return _this2.scrollToDomRef('location');
                      },
                      className: activeTab === 'location' ? styles.activeTab : ''
                    },
                    'V\u1ECB Tr\xED'
                  ),
                  _react2.default.createElement(
                    'div',
                    {
                      onClick: function onClick() {
                        return _this2.scrollToDomRef('gallery');
                      },
                      className: activeTab === 'gallery' ? styles.activeTab : ''
                    },
                    'H\xECnh \u1EA3nh'
                  ),
                  _react2.default.createElement(
                    'div',
                    {
                      onClick: function onClick() {
                        return _this2.scrollToDomRef('about');
                      },
                      className: activeTab === 'about' ? styles.activeTab : ''
                    },
                    '\u01AFu \u0111\xE3i c\xF9ng chuy\xEAn m\u1EE5c'
                  )
                )
              ),
              _react2.default.createElement(
                'div',
                { className: styles.contentTabs },
                _react2.default.createElement(
                  'div',
                  {
                    className: styles.contentTab + ' ' + styles.comment,
                    id: 'comment',
                    ref: 'descript'
                  },
                  _react2.default.createElement(
                    'div',
                    { className: styles.headerTab },
                    _react2.default.createElement(
                      'h2',
                      { className: styles.leftHeaderTab },
                      _react2.default.createElement(_reactBootstrap.Glyphicon, { className: styles.icon, glyph: 'th-large' }),
                      'M\xF4 t\u1EA3 d\u1ECBch v\u1EE5'
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: styles.bodyTab },
                    _react2.default.createElement('div', {
                      dangerouslySetInnerHTML: {
                        __html: data && data.service.description ? data.service.description : 'Mô tả dịch vụ chưa được cập nhập!'
                      }
                    })
                  )
                ),
                _react2.default.createElement(
                  'div',
                  {
                    className: styles.contentTab + ' ' + styles.comment,
                    id: 'comment',
                    ref: 'comment'
                  },
                  _react2.default.createElement(
                    'div',
                    { className: styles.headerTab },
                    _react2.default.createElement(
                      'h2',
                      { className: styles.leftHeaderTab },
                      _react2.default.createElement(_reactBootstrap.Glyphicon, { className: styles.icon, glyph: 'pencil' }),
                      '\u0110i\u1EC1u kho\u1EA3n s\u1EED d\u1EE5ng'
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: styles.bodyTab },
                    _react2.default.createElement('div', {
                      dangerouslySetInnerHTML: {
                        __html: data && data.campaign.condition ? data.campaign.condition : 'Điều khoản chưa được cập nhập!'
                      }
                    })
                  )
                ),
                shop && _react2.default.createElement(_LocationDetail2.default, {
                  shop: shop,
                  style: require('../../containers/Promotion/PromotionDetail.scss'),
                  ref: 'location'
                }),
                _react2.default.createElement(_GalleryDetail2.default, {
                  style: require('../../containers/Promotion/PromotionDetail.scss'),
                  ref: 'gallery'
                }),
                _react2.default.createElement(
                  'div',
                  {
                    className: styles.contentTab + ' ' + styles.comment,
                    id: 'comment',
                    ref: 'about'
                  },
                  _react2.default.createElement(
                    'div',
                    { className: styles.bodyTab },
                    _react2.default.createElement(_VoucherHorizontalList2.default, {
                      boxNumber: 4,
                      promotionDetail: true,
                      voucherHandle: voucherHandle
                    })
                  )
                )
              )
            )
          ),
          !data && !voucherLoading && _react2.default.createElement(
            'div',
            { className: styles.notFound },
            _react2.default.createElement(
              'div',
              { className: styles.textNotFound },
              ' \u01AFu \u0111\xE3i kh\xF4ng t\u1ED3n t\u1EA1i'
            ),
            _react2.default.createElement(_VoucherHorizontalList2.default, { boxNumber: 8 })
          )
        ),
        _react2.default.createElement(
          _reactBootstrap.Modal,
          {
            show: showModalAlert,
            onHide: this.handleCloseModalAlert,
            className: 'modal-alert-login',
            backdrop: true
          },
          _react2.default.createElement(
            'div',
            { className: styles.modalAlert },
            _react2.default.createElement(
              'div',
              { className: styles.headerAlert },
              'Th\xF4ng b\xE1o'
            ),
            _react2.default.createElement(
              'div',
              { className: styles.contentAlert },
              'Vui l\xF2ng truy c\u1EADp b\u1EB1ng \u0111i\u1EC7n tho\u1EA1i \u0111\u1EC3 s\u1EED d\u1EE5ng \u01B0u \u0111\xE3i n\xE0y'
            ),
            _react2.default.createElement(
              'div',
              {
                className: styles.btnLogin,
                onClick: function onClick() {
                  return _this2.handleCloseModalAlert(false);
                }
              },
              'OK'
            )
          )
        )
      );
    }
  }]);
  return PromotionDetail;
}(_react.Component), _class2.propTypes = {
  PACKAGE_DETAIL: _react.PropTypes.object,
  loaded: _react.PropTypes.bool,
  loading: _react.PropTypes.bool,
  location: _react.PropTypes.object,
  params: _react.PropTypes.object,
  shop: _react.PropTypes.object,
  getShopData: _react.PropTypes.func.isRequired,
  getRewardDetail: _react.PropTypes.func.isRequired
}, _temp2)) || _class) || _class);
exports.default = PromotionDetail;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Promotion/PromotionDetail.js
// module id = 1688
// module chunks = 0